import React, { useContext } from 'react'
import { ThemeContext } from '../../../auth';
import { Modal } from 'react-bootstrap';
import CalendarMeeting from '../../CalendarMeeting';

function ModalShcedule({
    meetingIncoming,
    showCalendar,
    setShowCalendar
}) {

    const { theme } = useContext(ThemeContext);

    const handleClose = () => {
        setShowCalendar(false)
    };

    return (
        <Modal
            show={showCalendar}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered
            size='xl'
            data-bs-theme={theme === 'light' ? 'dark' : ''}
        >
            <Modal.Header closeButton >
                <Modal.Title style={{ fontFamily: 'Poppins-Medium', color: theme === 'light' ? '#FFFFFF' : '#222222' }}>
                    Schedular
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <CalendarMeeting
                    meetingIncoming={meetingIncoming}
                />
            </Modal.Body>
        </Modal>
    )
}

export default ModalShcedule
